import {useSelector} from 'react-redux';

import fwuService from '@/services/fwu/fwuService';
import {selectIsFwuCheckEnabled} from '@/state/selectors/consumerAggregatedSettings';
import {selectDeviceType, selectIsSelectedDeviceConnectedToIot} from '@/state/selectors/device';

const useFwuCheckEnabled = () => {
    const isDeviceConnectedToIot = useSelector(selectIsSelectedDeviceConnectedToIot);
    const isFwuCheckEnabled = useSelector(selectIsFwuCheckEnabled);
    const deviceType = useSelector(selectDeviceType);
    const isFwuAvailable = fwuService.isFwuAvailable(deviceType);

    return isDeviceConnectedToIot && isFwuAvailable && !isFwuCheckEnabled;
};

export default useFwuCheckEnabled;
